module.exports = __webpack_public_path__ + "img/progress_028.43368b3f.png";